/**
 * AWS region to IATA airport code mapping.
 * Used for constructing ops role names: Ops@{claim}@{stage}@{airportCode}
 */
export const REGION_TO_AIRPORT_CODE: Record<string, string> = {
  'us-east-1': 'iad',
  'us-east-2': 'cmh',
  'us-west-2': 'pdx',
  'af-south-1': 'cpt',
  'ap-northeast-2': 'icn',
  'ap-southeast-1': 'sin',
  'ap-southeast-2': 'syd',
  'eu-central-1': 'fra',
  'eu-north-1': 'arn',
  'eu-west-1': 'dub',
  'me-south-1': 'bah',
  'sa-east-1': 'gru',
};

export function getAirportCodeForRegion(region: string): string {
  const code = REGION_TO_AIRPORT_CODE[region];
  if (code === undefined) {
    throw new Error(`No airport code mapping for region: ${region}`);
  }
  return code;
}
